import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MD - Obstetrics & Gynecology",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Ectopic Pregnancy Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, DNB - Obstetrics & Gynecology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Laparoscopic Surgery Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Obstetrics & Gynecology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Reproductive Health Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, DNB - Reproductive Medicine",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Emergency Gynecology"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Obstetrics & Gynecology",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "High-Risk Pregnancy Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MD - Gynecology",
    fee: "FREE Consultation",
    rating: "4.5/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimally Invasive Surgery"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Ectopic Pregnancy Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Connect with top gynecologists and reproductive health specialists for expert ectopic pregnancy treatment and care.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const EctopicPregnancy = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Ectopic Pregnancy Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Expert Medical & Surgical Care with 98% Success Rate. Preserve Fertility, Ensure Your Health and Future.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Emergency Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              View Treatment Options
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>2,500+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Successful Treatments</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>98%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>85%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Fertility Preservation</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>24/7</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Emergency Care</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "causes", label: "Causes", icon: "🎯" },
              { id: "types", label: "Types", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "recovery", label: "Recovery", icon: "🔄" },
              { id: "prevention", label: "Prevention", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Ectopic Pregnancy Treatment</span>
            </h2>
          </div>

          {/* What is Ectopic Pregnancy */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Ectopic Pregnancy
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                An ectopic pregnancy occurs when a fertilized egg implants and grows outside the main cavity of the uterus, 
                most commonly in the fallopian tube. This condition is a medical emergency that requires immediate treatment 
                as the growing embryo can rupture the fallopian tube, causing life-threatening internal bleeding.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Tubal Pregnancy (95% of cases)</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      The fertilized egg implants in the fallopian tube. This is the most common type 
                      and can occur in different parts of the tube - ampullary, isthmic, or fimbrial.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Non-Tubal Ectopic (5% of cases)</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Includes ovarian, cervical, abdominal, or cesarean scar pregnancies. 
                      These are rare but often more complex to manage and treat.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Symptoms */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Symptoms Guide
            </h3>

            <div className="row">
              {[
                {
                  title: "Abdominal Pain", 
                  description: "Sharp, stabbing pain in the lower abdomen, often on one side",
                  details: "May start as mild discomfort and progress to severe pain"
                },
                {
                  title: "Vaginal Bleeding", 
                  description: "Light to heavy vaginal bleeding, often darker than menstrual blood",
                  details: "Different from normal period bleeding in color and timing"
                },
                {
                  title: "Shoulder Tip Pain", 
                  description: "Referred pain in the shoulder tip due to internal bleeding",
                  details: "Medical emergency indicating possible rupture"
                },
                {
                  title: "Gastrointestinal Symptoms", 
                  description: "Nausea, vomiting, diarrhea, or pain with bowel movements",
                  details: "Often mistaken for gastrointestinal issues"
                },
                {
                  title: "Weakness & Dizziness", 
                  description: "Lightheadedness, fainting, or feeling faint due to blood loss",
                  details: "Sign of significant internal bleeding"
                },
                {
                  title: "Pelvic Pressure", 
                  description: "Feeling of pressure in the rectum or pelvic area",
                  details: "Due to blood accumulation in the pelvic cavity"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Types of Ectopic Pregnancy */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Ectopic Pregnancy
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Tubal Ectopic",
                    description: "Occurs in fallopian tubes - ampullary (most common), isthmic, fimbrial, or interstitial. Risk of rupture increases with gestational age.",
                    severity: "High Risk"
                  },
                  {
                    type: "Ovarian Ectopic",
                    description: "Rare implantation on the ovary. Difficult to diagnose and manage, often requiring surgical intervention.",
                    severity: "Complex"
                  },
                  {
                    type: "Cervical Ectopic",
                    description: "Implantation in the cervical canal. High risk of severe bleeding, often requiring specialized management.",
                    severity: "Critical"
                  },
                  {
                    type: "Abdominal Ectopic",
                    description: "Implantation in the abdominal cavity. Can progress to advanced gestation but with high maternal risk.",
                    severity: "Rare & Complex"
                  },
                  {
                    type: "Cesarean Scar Ectopic",
                    description: "Implantation in previous cesarean section scar. Increasing incidence with rising C-section rates.",
                    severity: "Emerging Concern"
                  },
                  {
                    type: "Heterotopic Pregnancy",
                    description: "Rare simultaneous intrauterine and ectopic pregnancy. Often missed in early ultrasound scans.",
                    severity: "Very Rare"
                  }
                ].map((ectopicType, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {ectopicType.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {ectopicType.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {ectopicType.severity}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Damaged or scarred fallopian tubes from previous infections or surgeries</li>
                      <li style={{ marginBottom: "10px" }}>Pelvic inflammatory disease (PID) causing tubal damage</li>
                      <li style={{ marginBottom: "10px" }}>Previous ectopic pregnancy (10-15% recurrence risk)</li>
                      <li style={{ marginBottom: "10px" }}>Endometriosis affecting tubal function</li>
                      <li>Hormonal factors and abnormal embryo development</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maternal age over 35 years</li>
                      <li style={{ marginBottom: "10px" }}>History of sexually transmitted infections</li>
                      <li style={{ marginBottom: "10px" }}>Smoking (doubles the risk)</li>
                      <li style={{ marginBottom: "10px" }}>Fertility treatments and IVF</li>
                      <li>Tubal surgery including tubal ligation reversal</li>
                      <li style={{ marginBottom: "10px" }}>Intrauterine device (IUD) use</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Advanced Treatment Options
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Medical Management (Methotrexate)
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Methotrexate is a medication that stops the growth of rapidly dividing cells, 
                    including the pregnancy tissue. This non-surgical option is suitable for early, 
                    unruptured ectopic pregnancies with specific criteria.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Stable vital signs</li>
                          <li style={{ marginBottom: "8px" }}>No active bleeding</li>
                          <li style={{ marginBottom: "8px" }}>Pregnancy size &lt; 4cm</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>No fetal cardiac activity</li>
                          <li style={{ marginBottom: "8px" }}>HCG &lt; 5000 mIU/mL</li>
                          <li style={{ marginBottom: "8px" }}>Patient compliance with follow-up</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Success Rates:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Overall success: 85-95%</li>
                      <li style={{ marginBottom: "8px" }}>Single dose success: 65-75%</li>
                      <li>Multiple dose success: 85-95%</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Treatment Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Laparoscopic Surgery:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Salpingostomy:</strong> Removal of ectopic pregnancy while preserving the fallopian tube</li>
                      <li style={{ marginBottom: "10px" }}><strong>Salpingectomy:</strong> Removal of the affected fallopian tube</li>
                      <li style={{ marginBottom: "10px" }}><strong>Cornual Resection:</strong> For interstitial ectopic pregnancies</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Open Surgery (Laparotomy):</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Required for unstable patients or ruptured ectopic</li>
                      <li style={{ marginBottom: "10px" }}>Emergency procedure for life-threatening bleeding</li>
                      <li>May involve blood transfusion and intensive care</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Fertility Preservation:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Tube-sparing surgery when possible</li>
                      <li style={{ marginBottom: "10px" }}>Future IVF options if both tubes affected</li>
                      <li>85% future intrauterine pregnancy rate with one healthy tube</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recovery Process */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Recovery Timeline After Treatment
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Immediate Recovery",
                    activities: ["Pain management", "Wound care", "Rest and limited activity", "Follow-up HCG monitoring"]
                  },
                  {
                    period: "Week 3-4",
                    title: "Early Healing",
                    activities: ["Gradual return to light activities", "Emotional support", "Contraception counseling", "Nutrition focus"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Physical Recovery",
                    activities: ["Resume normal activities", "Return to work", "Pelvic rest completed", "Exercise gradually"]
                  },
                  {
                    period: "Month 4-6",
                    title: "Emotional & Future Planning",
                    activities: ["Complete physical recovery", "Future pregnancy planning", "Emotional healing", "Long-term follow-up"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention Section */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Risk Reduction
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Lifestyle Measures</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Quit smoking - reduces risk by 50%</li>
                      <li style={{ marginBottom: "10px" }}>Practice safe sex to prevent STIs and PID</li>
                      <li style={{ marginBottom: "10px" }}>Regular gynecological check-ups</li>
                      <li>Prompt treatment of pelvic infections</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Medical Management</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Early pregnancy monitoring for high-risk patients</li>
                      <li style={{ marginBottom: "10px" }}>Prompt treatment of pelvic inflammatory disease</li>
                      <li style={{ marginBottom: "10px" }}>Careful consideration of fertility treatments</li>
                      <li>Appropriate contraceptive choices</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Can I have a normal pregnancy after an ectopic pregnancy?",
                  answer: "Yes, most women who have had one ectopic pregnancy can go on to have a successful pregnancy in the future. The likelihood depends on the health of your remaining fallopian tube and other fertility factors. About 65% of women achieve a successful pregnancy within 18 months of an ectopic pregnancy."
                },
                {
                  question: "What are the emergency signs of a ruptured ectopic pregnancy?",
                  answer: "Emergency signs include severe abdominal pain, heavy vaginal bleeding, shoulder tip pain, dizziness or fainting, rapid heartbeat, and pale skin. These symptoms indicate possible rupture and internal bleeding, requiring immediate medical attention at the nearest emergency department."
                },
                {
                  question: "How soon can I try to conceive after ectopic pregnancy treatment?",
                  answer: "After methotrexate treatment, it's recommended to wait at least 3 months before trying to conceive. After surgical treatment, most doctors recommend waiting until you've had at least two normal menstrual cycles. Your doctor will provide personalized guidance based on your specific situation."
                },
                {
                  question: "Does ectopic pregnancy affect future fertility?",
                  answer: "Fertility after ectopic pregnancy depends on several factors including the condition of your fallopian tubes, your age, and whether you have other fertility issues. With one healthy fallopian tube, the chance of future natural pregnancy is about 85%. IVF may be an option if both tubes are damaged."
                },
                {
                  question: "Can ectopic pregnancy be detected early?",
                  answer: "Yes, early detection is possible through blood tests (HCG levels) and transvaginal ultrasound. Women with risk factors should have early pregnancy monitoring. Rising HCG levels that don't double appropriately and the absence of an intrauterine gestational sac on ultrasound are key indicators."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Need Immediate Care for Suspected Ectopic Pregnancy?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Don't wait if you're experiencing symptoms. Our emergency gynecology team is available 24/7 to provide immediate care and treatment.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Emergency Consultation - 24/7
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Call our emergency line: <strong>080-6541-7705</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default EctopicPregnancy;